import { IconMoreFilled } from '@zillow/constellation-icons/react/filled/icon-more-filled';
import { forwardRef } from 'react';

import { cx } from '@/styled-system/css';

import { IconButton } from '../icon-button';
import { propertyCardMenuTriggerStyles } from './styles/property-card-menu-trigger.styles';
import type { PropertyCardMenuTriggerPropsInterface } from './types/property-card-menu-trigger.types';

/**
 * A custom menu trigger used by `PropertyCard` to show a menu of actions.
 *
 * @since 8.63.0
 */
export const PropertyCardMenuTrigger = forwardRef<
  HTMLButtonElement,
  PropertyCardMenuTriggerPropsInterface
>((props: PropertyCardMenuTriggerPropsInterface, forwardedRef) => {
  const { css: cssProp, ...rest } = props;

  return (
    <IconButton
      ref={forwardedRef}
      data-c11n-component="PropertyCard.MenuTrigger"
      data-c11n-version={__C11N_VERSION__}
      icon={<IconMoreFilled />}
      emphasis="bare"
      tone="brand"
      title="More"
      css={{ ...propertyCardMenuTriggerStyles, ...cssProp }}
      {...rest}
      className={cx('c11n_property-card__menu-trigger', rest.className)}
    />
  );
});

PropertyCardMenuTrigger.displayName = 'PropertyCard.MenuTrigger';
